export function getActivityDateKey(createdAt) {
    if (!createdAt) {
        return 'Unknown';
    }

    const parts = createdAt.split(' ');

    if (parts.length >= 3) {
        return `${parts[0]} ${parts[1]} ${parts[2]}`;
    }

    return createdAt;
}

export function getActivityTimeLabel(createdAt) {
    if (!createdAt) {
        return '—';
    }

    const parts = createdAt.split(' ');

    if (parts.length >= 5) {
        return `${parts[3]} ${parts[4]}`;
    }

    return createdAt;
}

export function formatActivityDateLabel(dateKey) {
    if (!dateKey || dateKey === 'Unknown') {
        return dateKey;
    }

    const date = new Date(dateKey);

    if (Number.isNaN(date.getTime())) {
        return dateKey;
    }

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
        return 'Today';
    }

    if (date.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
    }

    return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

export function groupActivitiesByDate(records) {
    if (!records?.length) {
        return [];
    }

    const groupMap = new Map();
    const order = [];

    records.forEach((item) => {
        const dateKey = getActivityDateKey(item.createdAt);

        if (!groupMap.has(dateKey)) {
            groupMap.set(dateKey, []);
            order.push(dateKey);
        }

        groupMap.get(dateKey).push(item);
    });

    return order.map((dateKey) => ({
        dateKey,
        label: formatActivityDateLabel(dateKey),
        items: groupMap.get(dateKey),
    }));
}
